import { useChatListenersSocket } from "hooks/useChatListenersSocket";
import { useChatFeature } from "./hooks/useChatFeature";
import { useMessageSelection } from "./hooks/useMessageSelection";
import { useChatContextStore } from "./providers/ChatContextProvider";
import { ChatHeaderBar } from "./ui/ChatHeaderBar";
import { ChatSelectionHeader } from "./ui/ChatSelectionHeader";

type ChatHeaderPanelProps = {
  onGoBack: () => void;
  onClose: () => void;
  onViewParticipants: () => void;
  className?: string;
};

const ChatHeaderPanel = ({
  onGoBack,
  onClose,
  onViewParticipants,
  className,
}: ChatHeaderPanelProps) => {
  const {
    discussion,
    title,
    discussionContext,
    discussionContextType,
    discussionId,
    editingMessage,
    selectedMessages,
  } = useChatContextStore();

  const { stopActivityKind, showHeader, discussionType } = useChatFeature();
  const { typingLabel } = useChatListenersSocket({
    discussionId: discussionId ?? undefined,
  });

  const { isDeleting, onEdit, onCancelEdit, onDeselect, onDelete, onCopy } =
    useMessageSelection();

  if (selectedMessages.length > 0) {
    return (
      <ChatSelectionHeader
        selectedMessages={selectedMessages}
        onDeselect={onDeselect}
        onEdit={onEdit}
        onCopy={onCopy}
        onDelete={onDelete}
        isDeleting={isDeleting}
      />
    );
  }

  if (!showHeader) return null;

  const context = discussion?.context ?? discussionContextType ?? undefined;

  const sharedProps = {
    discussionType,
    context,
    stopActivityKind,
    participantName: discussion?.participantName,
    avatarId: discussion?.image,
    title,
    discussionContext,
    typingLabel,
    className,
  };

  if (editingMessage) {
    return (
      <ChatHeaderBar
        {...sharedProps}
        onGoBack={onCancelEdit}
      />
    );
  }

  return (
    <ChatHeaderBar
      {...sharedProps}
      showActions
      onGoBack={onGoBack}
      onClose={onClose}
      onViewParticipants={onViewParticipants}
      phone={discussion?.phone}
    />
  );
};

export default ChatHeaderPanel;
